import Vue from 'vue';
import router from './router/router';
import store from './store/store';

import LoadingOverlay from '@/components/loading-overlay/loading-overlay';
import BackgroundVideo from '@/components/background-video/background-video';
import ProgressBar from '@/components/progress-bar/progress-bar';

import VueI18n, {LocaleMessages} from 'vue-i18n';
import VueMeta from 'vue-meta';
import 'fullpage.js/vendors/scrolloverflow';
import VueFullPage from 'vue-fullpage.js';

import { AppLanguages, AppLanguageHandler} from '@/utils/handlers/app-language-handler';

const App = () => import('@/app/app.vue');

Vue.component('loading-overlay', LoadingOverlay);
Vue.component('background-video', BackgroundVideo);
Vue.component('progress-bar', ProgressBar);

Vue.use(VueI18n);
Vue.use(VueMeta);
Vue.use(VueFullPage);

// Initialize json strings texts
const appMessages: LocaleMessages = AppLanguageHandler.setApplicationMessages();

// Initialize Vuei18n internationalization plugin.
const i18n: VueI18n = new VueI18n({
  fallbackLocale: AppLanguages.FR,
  messages: appMessages,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
